<script setup lang="ts">
const props = defineProps<{ name: string }>();

const icon = computed(() => props.name.replace('mobile-menu-bar/', ''));
</script>

<template>
  <!-- ── MENU (hamburger) ───────────────────────── -->
  <div
    v-if="icon === 'menu'"
    aria-hidden="true"
    class="icon icon-menu"
  >
    <span /><span /><span />
  </div>

  <!-- ── CLOSE (X) ──────────────────────────────── -->
  <div
    v-else-if="icon === 'close'"
    aria-hidden="true"
    class="icon icon-close"
  />

  <!-- ── SUPORTE (speech bubble) ───────────────── -->
  <div
    v-else-if="icon === 'suporte'"
    aria-hidden="true"
    class="icon icon-suporte"
  >
    <span class="line" /><span class="line short" />
  </div>

  <!-- ── TORNEIOS (trophy) ──────────────────────── -->
  <div
    v-else-if="icon === 'torneios'"
    aria-hidden="true"
    class="icon icon-torneios"
  >
    <div class="cup" />
    <div class="stem" />
    <div class="base" />
  </div>

  <!-- ── MISSOES (target) ───────────────────────── -->
  <div
    v-else-if="icon === 'missoes'"
    aria-hidden="true"
    class="icon icon-missoes"
  >
    <div class="ring outer" />
    <div class="ring mid" />
    <div class="dot" />
  </div>

  <!-- ── ENTRAR (login arrow) ──────────────────── -->
  <div
    v-else-if="icon === 'entrar'"
    aria-hidden="true"
    class="icon icon-entrar"
  >
    <div class="arrow-body" />
    <div class="door-bar" />
  </div>

  <!-- ── ESPORTE ──────────────────────────────────── -->
  <svg
    v-else-if="icon === 'esporte'"
    aria-hidden="true"
    class="icon"
    fill="none"
    height="18"
    viewBox="0 0 26 18"
    width="26"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26 18H13.65V13.4558C15.8559 13.1424 17.55 11.2701 17.55 9C17.55 6.72991 15.8559 4.85759 13.65 4.5442V0H26V3.85714H22.1H20.8V5.14286V12.8571V14.1429H22.1H26V18ZM12.35 4.5442C10.1441 4.85759 8.45 6.72991 8.45 9C8.45 11.2701 10.1441 13.1424 12.35 13.4558V18H0V14.1429H3.9H5.2V12.8571V5.14286V3.85714H3.9H0V0H12.35V4.5442ZM12.35 12.15C10.8672 11.8527 9.75 10.5549 9.75 9C9.75 7.44509 10.8672 6.14732 12.35 5.85V12.15ZM13.65 12.15V5.85C15.1328 6.14732 16.25 7.44509 16.25 9C16.25 10.5549 15.1328 11.8527 13.65 12.15ZM22.1 5.14286H26V12.8571H22.1V5.14286ZM3.9 12.8571H0V5.14286H3.9V12.8571Z"
      fill="currentColor"
    />
  </svg>

  <!-- ── CASSINO (diamond) ──────────────────────── -->
  <div
    v-else-if="icon === 'cassino'"
    aria-hidden="true"
    class="icon icon-cassino"
  />

  <!-- ── HOMEPAGE (house) ──────────────────────── -->
  <div
    v-else-if="icon === 'homepage'"
    aria-hidden="true"
    class="icon icon-homepage"
  />

  <!-- ── SLOTS ──────────────────────────────────── -->
  <svg
    v-else-if="icon === 'slots'"
    aria-hidden="true"
    class="icon"
    fill="none"
    height="22"
    viewBox="0 0 25 22"
    width="25"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.8618 0.127886C19.1 0.249958 19.1453 0.3139 19.5139 1.05796L19.9108 1.86015H20.6707C21.3228 1.86015 21.4702 1.87759 21.6743 1.97641C22.0316 2.15661 22.0599 2.22055 22.3775 3.46453L22.4342 3.70867L22.9899 3.73192C23.7951 3.7668 24.2147 4.01676 24.5379 4.65037L24.674 4.91195L24.691 11.7306C24.6967 16.2763 24.6853 18.6247 24.6456 18.7759C24.5492 19.1479 24.2487 19.5432 23.9085 19.7466C23.7384 19.8513 23.5456 19.9385 23.4775 19.9385C23.3584 19.9385 23.3528 19.9675 23.3301 20.5081C23.3074 21.165 23.1997 21.4091 22.8141 21.6707L22.5816 21.8277H14.4956H6.40967L6.17718 21.6707C5.7916 21.4091 5.68386 21.165 5.66118 20.5081C5.63849 19.9675 5.63282 19.9385 5.51375 19.9385C5.4457 19.9385 5.25291 19.8513 5.0828 19.7466C4.74824 19.5432 4.44771 19.1537 4.34565 18.7875C4.31162 18.6538 4.28894 17.5842 4.28894 16.0322V13.4977L3.27962 13.4745C2.35534 13.457 2.25327 13.4454 2.02079 13.3175C1.6749 13.1315 1.47076 12.928 1.29498 12.5851L1.14188 12.2944L1.12487 9.67859L1.10786 7.06275L0.852692 6.92324C0.574842 6.7721 0.353699 6.51052 0.143894 6.10361C-0.0488987 5.71996 -0.0488987 4.97009 0.149565 4.56318C0.325346 4.19115 0.665569 3.84237 1.02847 3.66217C1.26096 3.54591 1.39705 3.51684 1.79397 3.51684C2.36101 3.51684 2.70123 3.65635 3.06981 4.04001C3.44406 4.41785 3.57447 4.76663 3.58014 5.34793C3.58014 5.80134 3.56313 5.87109 3.38735 6.20825C3.19456 6.56865 2.92805 6.84186 2.62752 6.98137L2.47442 7.05113V9.5042C2.47442 11.3295 2.49143 11.9689 2.54247 12.0212C2.58783 12.0677 2.87135 12.091 3.44973 12.091H4.28327L4.30028 8.49855L4.3173 4.91195L4.45338 4.65037C4.7766 4.01095 5.19053 3.77261 6.04109 3.72611L6.63081 3.69123L6.85196 3.02855C7.10712 2.26124 7.18651 2.13336 7.49838 1.97641C7.69117 1.87759 7.8386 1.86015 8.40564 1.86015H9.08042L9.47734 1.05796C9.84592 0.3139 9.89128 0.249958 10.1294 0.127886L10.3789 0H14.4956H18.6123L18.8618 0.127886ZM15.8565 11.8584V15.5787H19.2588H22.661V11.8584V8.13815H19.2588H15.8565V11.8584ZM6.33028 11.8584V15.5787H9.73251H13.1347V11.8584V8.13815H9.73251H6.33028V11.8584Z"
      fill="currentColor"
    />
    <path
      d="M19.3437 9.30089C19.5138 9.36484 19.5592 9.44041 19.8484 10.1089C19.9901 10.446 20.1376 10.7367 20.1773 10.7658C20.217 10.789 20.5005 10.8123 20.8067 10.8123C21.5211 10.8123 21.6969 10.8936 21.6969 11.2424C21.6969 11.3703 21.6005 11.5098 21.2433 11.8819C20.9938 12.1434 20.7897 12.405 20.7897 12.4631C20.7897 12.5155 20.8634 12.8759 20.9598 13.2537C21.1582 14.0617 21.1639 14.1896 21.0278 14.3175C20.8464 14.4861 20.6366 14.4279 19.9675 14.0385C19.6102 13.8292 19.287 13.6606 19.2473 13.6606C19.2076 13.6606 18.8787 13.8292 18.5158 14.0385C17.773 14.4628 17.5632 14.5093 17.4101 14.271C17.3194 14.1315 17.3251 14.085 17.4952 13.399C17.7447 12.3643 17.756 12.405 17.2173 11.8295C16.9678 11.5621 16.7637 11.2947 16.7637 11.2308C16.7637 11.1669 16.8147 11.0564 16.8714 10.9808C16.9735 10.853 17.0302 10.8413 17.6539 10.8123L18.3231 10.7832L18.5385 10.3182C19.0092 9.28346 19.0772 9.20207 19.3437 9.30089Z"
      fill="currentColor"
    />
    <path
      d="M9.90612 9.32415C9.99685 9.37065 10.1273 9.59154 10.3087 10.0217C10.4618 10.3705 10.6093 10.6902 10.6433 10.7309C10.683 10.7774 10.9268 10.8065 11.3521 10.8239C11.9645 10.8413 12.0155 10.853 12.1176 10.9808C12.1743 11.0564 12.2253 11.1669 12.2253 11.2308C12.2253 11.2947 12.0212 11.5621 11.7717 11.8295C11.233 12.405 11.2443 12.3643 11.4938 13.399C11.6639 14.085 11.6696 14.1315 11.5789 14.271C11.4258 14.5093 11.216 14.4628 10.4732 14.0385C10.1103 13.8292 9.77571 13.6606 9.73601 13.6606C9.69065 13.6606 9.36744 13.8292 9.01587 14.0385C8.3411 14.4337 8.11428 14.4919 7.95551 14.3117C7.82509 14.1663 7.83076 14.0501 8.02923 13.2537C8.11995 12.8759 8.19934 12.5155 8.19934 12.4631C8.19934 12.405 7.99521 12.1434 7.74571 11.8819C7.38847 11.5098 7.29208 11.3703 7.29208 11.2424C7.29208 10.8936 7.46786 10.8123 8.188 10.8123C8.8571 10.8123 8.84009 10.8239 9.16898 10.0508C9.48085 9.30671 9.61694 9.17301 9.90612 9.32415Z"
      fill="currentColor"
    />
  </svg>

  <!-- ── AO VIVO ───────────────────────────────── -->
  <svg
    v-else-if="icon === 'ao-vivo'"
    aria-hidden="true"
    class="icon"
    fill="none"
    height="24"
    viewBox="0 0 31 24"
    width="31"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 10.4245L10.6562 0L21.3124 10.4245L10.6562 20.8491L0 10.4245ZM11.7979 10.4245C11.7979 10.1283 11.6777 9.84423 11.4635 9.63477C11.2494 9.42531 10.959 9.30763 10.6562 9.30763C10.3534 9.30763 10.063 9.42531 9.84888 9.63477C9.63476 9.84423 9.51447 10.1283 9.51447 10.4245C9.51447 10.7208 9.63476 11.0049 9.84888 11.2143C10.063 11.4238 10.3534 11.5415 10.6562 11.5415C10.959 11.5415 11.2494 11.4238 11.4635 11.2143C11.6777 11.0049 11.7979 10.7208 11.7979 10.4245ZM4.56695 11.5415C4.86975 11.5415 5.16016 11.4238 5.37427 11.2143C5.58839 11.0049 5.70868 10.7208 5.70868 10.4245C5.70868 10.1283 5.58839 9.84423 5.37427 9.63477C5.16016 9.42531 4.86975 9.30763 4.56695 9.30763C4.26414 9.30763 3.97373 9.42531 3.75962 9.63477C3.5455 9.84423 3.42521 10.1283 3.42521 10.4245C3.42521 10.7208 3.5455 11.0049 3.75962 11.2143C3.97373 11.4238 4.26414 11.5415 4.56695 11.5415ZM10.6562 15.2645C10.3534 15.2645 10.063 15.3822 9.84888 15.5917C9.63476 15.8011 9.51447 16.0852 9.51447 16.3814C9.51447 16.6777 9.63476 16.9617 9.84888 17.1712C10.063 17.3807 10.3534 17.4983 10.6562 17.4983C10.959 17.4983 11.2494 17.3807 11.4635 17.1712C11.6777 16.9617 11.7979 16.6777 11.7979 16.3814C11.7979 16.0852 11.6777 15.8011 11.4635 15.5917C11.2494 15.3822 10.959 15.2645 10.6562 15.2645ZM16.7455 11.5415C17.0483 11.5415 17.3387 11.4238 17.5528 11.2143C17.7669 11.0049 17.8872 10.7208 17.8872 10.4245C17.8872 10.1283 17.7669 9.84423 17.5528 9.63477C17.3387 9.42531 17.0483 9.30763 16.7455 9.30763C16.4427 9.30763 16.1523 9.42531 15.9381 9.63477C15.724 9.84423 15.6037 10.1283 15.6037 10.4245C15.6037 10.7208 15.724 11.0049 15.9381 11.2143C16.1523 11.4238 16.4427 11.5415 16.7455 11.5415ZM10.6562 3.35075C10.3534 3.35075 10.063 3.46842 9.84888 3.67788C9.63476 3.88735 9.51447 4.17144 9.51447 4.46766C9.51447 4.76389 9.63476 5.04798 9.84888 5.25744C10.063 5.4669 10.3534 5.58458 10.6562 5.58458C10.959 5.58458 11.2494 5.4669 11.4635 5.25744C11.6777 5.04798 11.7979 4.76389 11.7979 4.46766C11.7979 4.17144 11.6777 3.88735 11.4635 3.67788C11.2494 3.46842 10.959 3.35075 10.6562 3.35075ZM15.2232 18.4896L22.3875 11.4763L23.4674 10.4245L22.3923 9.37278L21.9451 8.93533H30.4463V23.8275H15.2232V18.4896ZM23.9765 16.3814C23.9765 16.0852 23.8562 15.8011 23.6421 15.5917C23.4279 15.3822 23.1375 15.2645 22.8347 15.2645C22.5319 15.2645 22.2415 15.3822 22.0274 15.5917C21.8133 15.8011 21.693 16.0852 21.693 16.3814C21.693 16.6777 21.8133 16.9617 22.0274 17.1712C22.2415 17.3807 22.5319 17.4983 22.8347 17.4983C23.1375 17.4983 23.4279 17.3807 23.6421 17.1712C23.8562 16.9617 23.9765 16.6777 23.9765 16.3814Z"
      fill="currentColor"
    />
  </svg>

  <!-- ── FALLBACK ──────────────────────────────── -->
  <div
    v-else
    aria-hidden="true"
    class="icon icon-fallback"
  />
</template>

<style scoped lang="scss">
// All icons use currentColor so the parent controls active/inactive state.
$c: currentColor;
$bw: 2px; // border/bar width

.icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  flex-shrink: 0;

  // Normaliza SVGs inline para o mesmo tamanho independente do viewBox original
  &:is(svg) {
    width: 22px;
    height: 22px;
    overflow: visible;
  }
}

// Ao vivo tem viewBox 31x24 (mais largo), precisa de mais espaço para parecer do mesmo tamanho
svg.icon[viewBox='0 0 31 24'] {
  width: 28px;
  height: 22px;
}

/* ─── MENU ─────────────────────────────────────── */
.icon-menu {
  flex-direction: column;
  justify-content: space-between;
  width: 20px;
  height: 14px;

  span {
    display: block;
    width: 100%;
    height: $bw;
    background: $c;
    border-radius: 1px;
  }
}

/* ─── CLOSE ─────────────────────────────────────── */
.icon-close {
  width: 18px;
  height: 18px;
  position: relative;

  &::before,
  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: $bw;
    background: $c;
    top: 50%;
    left: 0;
    border-radius: 1px;
    transform-origin: center;
  }

  &::before {
    transform: translateY(-50%) rotate(45deg);
  }
  &::after {
    transform: translateY(-50%) rotate(-45deg);
  }
}

/* ─── SUPORTE (chat bubble) ─────────────────────── */
.icon-suporte {
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 20px;
  height: 18px;
  border: $bw solid $c;
  border-radius: 3px;
  padding: 3px 3px 2px;
  position: relative;
  gap: 3px;

  &::after {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 4px;
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 5px solid $c;
  }

  .line {
    display: block;
    width: 100%;
    height: 1.5px;
    background: $c;
    border-radius: 1px;

    &.short {
      width: 65%;
    }
  }
}

/* ─── TORNEIOS (trophy) ──────────────────────────── */
.icon-torneios {
  flex-direction: column;
  align-items: center;
  width: 20px;
  height: 20px;
  justify-content: flex-start;
  gap: 0;

  .cup {
    width: 14px;
    height: 10px;
    border: $bw solid $c;
    border-bottom: none;
    border-radius: 0 0 50% 50% / 0 0 60% 60%;
    position: relative;
    flex-shrink: 0;

    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 0;
      width: 4px;
      height: 5px;
      border: $bw solid $c;
      border-top: none;
    }

    &::before {
      left: -5px;
      border-right: none;
      border-radius: 0 0 0 50%;
    }

    &::after {
      right: -5px;
      border-left: none;
      border-radius: 0 0 50% 0;
    }
  }

  .stem {
    width: $bw;
    height: 4px;
    background: $c;
    flex-shrink: 0;
  }

  .base {
    width: 12px;
    height: $bw;
    background: $c;
    border-radius: 1px;
    flex-shrink: 0;
  }
}

/* ─── MISSOES (target) ───────────────────────────── */
.icon-missoes {
  position: relative;
  width: 20px;
  height: 20px;

  .ring {
    position: absolute;
    border-radius: 50%;
    border: 1.5px solid $c;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    &.outer {
      width: 20px;
      height: 20px;
    }
    &.mid {
      width: 12px;
      height: 12px;
    }
  }

  .dot {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 4px;
    height: 4px;
    background: $c;
    border-radius: 50%;
    transform: translate(-50%, -50%);
  }
}

/* ─── ENTRAR (login) ────────────────────────────── */
.icon-entrar {
  position: relative;
  width: 20px;
  height: 18px;
  align-items: center;
  gap: 2px;

  .arrow-body {
    width: 12px;
    height: 12px;
    position: relative;
    flex-shrink: 0;

    // Horizontal bar
    &::before {
      content: '';
      position: absolute;
      width: 12px;
      height: $bw;
      background: $c;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      border-radius: 1px;
    }

    // Arrowhead
    &::after {
      content: '';
      position: absolute;
      width: 6px;
      height: 6px;
      border-top: $bw solid $c;
      border-right: $bw solid $c;
      top: 50%;
      right: 0;
      transform: translateY(-50%) rotate(45deg);
    }
  }

  .door-bar {
    width: $bw;
    height: 14px;
    background: $c;
    border-radius: 1px;
    flex-shrink: 0;
  }
}

/* ─── ESPORTE (sports circle + star) ───────────── */
.icon-esporte {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: $bw solid $c;
  position: relative;

  .inner-star {
    width: 8px;
    height: 8px;
    background: $c;
    clip-path: polygon(
      50% 0%,
      61% 35%,
      98% 35%,
      68% 57%,
      79% 91%,
      50% 70%,
      21% 91%,
      32% 57%,
      2% 35%,
      39% 35%
    );
  }
}

/* ─── CASSINO (diamond) ─────────────────────────── */
.icon-cassino {
  width: 16px;
  height: 16px;
  background: $c;
  clip-path: polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%);
}

/* ─── HOMEPAGE (house) ──────────────────────────── */
.icon-homepage {
  width: 22px;
  height: 20px;
  background: $c;
  clip-path: polygon(
    50% 0%,
    100% 46%,
    86% 46%,
    86% 100%,
    62% 100%,
    62% 68%,
    38% 68%,
    38% 100%,
    14% 100%,
    14% 46%,
    0% 46%
  );
}

/* ─── SLOTS ─────────────────────────────────────── */
.icon-slots {
  width: 20px;
  height: 18px;
  position: relative;
  flex-direction: row;
  align-items: flex-end;
  gap: 2px;

  .reels {
    display: flex;
    gap: 2px;
    align-items: flex-end;

    .reel {
      width: 4px;
      height: 12px;
      border: 1.5px solid $c;
      border-radius: 1px;
    }
  }

  .lever {
    position: absolute;
    right: 0;
    bottom: 0;
    width: $bw;
    height: 13px;
    background: $c;
    border-radius: 1px;

    .ball {
      position: absolute;
      top: -4px;
      left: 50%;
      transform: translateX(-50%);
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background: $c;
    }
  }
}

/* ─── AO VIVO (playing cards) ───────────────────── */
.icon-ao-vivo {
  position: relative;
  width: 22px;
  height: 20px;

  .card {
    position: absolute;
    width: 13px;
    height: 17px;
    border: 1.5px solid $c;
    border-radius: 2px;
    background: transparent;

    &.card-back {
      left: 0;
      top: 2px;
      transform: rotate(-12deg);
    }

    &.card-front {
      right: 0;
      top: 0;
      transform: rotate(8deg);

      &::after {
        content: '♥';
        position: absolute;
        top: 1px;
        left: 2px;
        font-size: 7px;
        line-height: 1;
        color: $c;
      }
    }
  }
}

/* ─── FALLBACK ──────────────────────────────────── */
.icon-fallback {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: $c;
}
</style>
